import {
  Box,
  ButtonBase,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useState, type ReactNode } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";

type Props = {
  title: string;
  children?: ReactNode;
  chipCount?: number | string;
  isLoading?: boolean;
};

export const CollapsiblePaper = ({
  title,
  children,
  chipCount,
  isLoading,
}: Props) => {
  const [isInvitationsExpanded, setIsInvitationsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsInvitationsExpanded(!isInvitationsExpanded);
  };

  return (
    <PrimaryPaper sx={{ padding: "0px !important" }}>
      <Stack>
        <ButtonBase
          onClick={children ? toggleExpanded : undefined}
          sx={{
            p: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: children ? "pointer" : "default",
          }}
        >
          <Box display="flex" gap={2} alignItems="center">
            <Typography variant="h6" fontSize="1.15rem">
              {title}
            </Typography>
            {chipCount !== undefined && (
              <Chip
                size="small"
                variant="filled"
                label={chipCount}
                sx={{ minWidth: 30, fontWeight: 500 }}
                color={chipCount === 0 ? "default" : "primary"}
              />
            )}
          </Box>
          {isLoading ? (
            <CircularProgress sx={{ color: "grey.300" }} size={20} />
          ) : (
            children &&
            (isInvitationsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)
          )}
        </ButtonBase>
        {isInvitationsExpanded && <Box sx={{ p: 4, pt: 0 }}>{children}</Box>}
      </Stack>
    </PrimaryPaper>
  );
};
